module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-parking-lot"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "component-card-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('ParkingLotActionButtons', {
    attrs: {
      "parkingLot": _vm.item
    }
  })], 1)], 1), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field-parking-lot-id"
  }, [_vm._v("PL" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field-parking-lot-name"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Assigned slots")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.slots))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Actual slots")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.parking_slots_count))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Occupied slots")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.vehicle_slots_count))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Disabled slots")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.vehicle_slots_disabled))])]), _c('div', {
    staticClass: "column shrink"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'parkingLot',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-243f6230!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/ParkingLot.vue
// module id = 2208
// module chunks = 1